/** Decodifica exp (ms) de um JWT LiveKit sem validar assinatura. */
export function getJwtExpiryMs(token: string): number | null {
  try {
    const parts = token.split('.');
    if (parts.length < 2) {
      return null;
    }
    const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
    if (typeof payload.exp === 'number' && Number.isFinite(payload.exp)) {
      return payload.exp * 1000;
    }
  } catch {
    /* ignore */
  }
  return null;
}

export function msUntilJwtExpiry(token: string): number | null {
  const expMs = getJwtExpiryMs(token);
  if (expMs == null) {
    return null;
  }
  return expMs - Date.now();
}

/** Renovar ~30 min antes do vencimento (mínimo 5 min). */
export function shouldRefreshJwt(token: string, refreshBeforeMs = 30 * 60 * 1000): boolean {
  const remaining = msUntilJwtExpiry(token);
  if (remaining == null) {
    return false;
  }
  return remaining <= refreshBeforeMs;
}
